import { render } from "./ApplicationLogo.vue?vue&type=template&id=ece5ab44"
import script from "./ApplicationLogo.vue?vue&type=script&lang=js"
export * from "./ApplicationLogo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/saleem/Sites/unitedtours/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__